import React, { useEffect, useState, useMemo } from 'react';
import EnhancedTable from '@components/_old/table/EnhancedTable';
import Loader from '@components/loader/Loader';
import { getHeaders } from '../content';
import BrandDrawer from '../../brand-drawer/BrandDrawer';
import { supervisorApiBaseUrl } from '@utils/env-utils';

const BASE_URL = supervisorApiBaseUrl;

const BrandsTable: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(100);

  // Drawer state
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editRow, setEditRow] = useState<any | null>(null);

  const loadData = () => {
    setLoading(true);
    fetch(`${BASE_URL}/api/Lookups/Insurance-Brands`)
      .then((res) => res.json())
      .then((result) => {
        const rows = Object.values(result || {});
        setData(rows);
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadData();
  }, []);

  // Table rows for Brands only
  const tableData = useMemo(
    () => ({
      pagedItems: data
        .slice(pageNumber * pageSize, pageNumber * pageSize + pageSize)
        .map((item) => ({
          ...item,
          columns: {
            Code: item.Code,
            Title: item.Title,
          },
          row: item,
        })),
      pageSize,
      pageNumber,
      totalCount: data.length,
    }),
    [data, pageNumber, pageSize]
  );

  // Existing codes (for add/edit duplicate check)
  const existingCodes = data
    .filter((b) => !editRow || b.Code !== editRow.Code)
    .map((b) => b.Code);

  // Column headers for Brands
  const headers = getHeaders(
    () => {
      setEditRow(null);
      setDrawerOpen(true);
    },
    (row: any) => {
      setEditRow(row);
      setDrawerOpen(true);
    }
  );

  // Actions
  const actions = [
    {
      title: '+ New',
      onClick: () => {
        setEditRow(null);
        setDrawerOpen(true);
      },
      isEntity: false,
      isBulk: false,
      iconUrl: '',
      hidden: false,
      disabled: false,
    },
  ];

  const handlePageChange = (page: number) => setPageNumber(page);
  const handleRowsPerPageChange = (size: number) => {
    setPageSize(size);
    setPageNumber(0);
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <EnhancedTable
        title={null}
        inlineTitle="Values"
        name="brands"
        entityName="Brand"
        entityIdColumnName="Id"
        orderByAscendingByDefault
        defaultOrderByColumn="Code"
        inline
        data={tableData}
        headers={headers}
        handlePageChange={handlePageChange}
        handleRowsPerPageChange={handleRowsPerPageChange}
        currentPage={pageNumber}
        usePagination
        disableSelection
        hideToolbar={false}
        actions={actions}
        loader={loading}
        showInlineFilter={false}
        rowsPerPageOptions={[5, 10, 25, 100]}
      />
      {drawerOpen && (
        <BrandDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          onSuccess={() => {
            setDrawerOpen(false);
            setEditRow(null);
            loadData();
          }}
          existingCodes={existingCodes}
          brand={editRow}
          isEdit={!!editRow}
        />
      )}
    </>
  );
};

export default BrandsTable;
